import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CommentForm from './CommentForm';
import CommentList from './CommentList';
import './iOS.css';

const Title = styled.div`
  text-align: center;
  width: 100%;
  font-weight: 600;
  font-size: 18px;
  text-decoration: underline;
  font-family: "Questrial", sans-serif;
  color: white;
`;

const Description = styled.div`
  font-size: 15px;
  line-height: 1.36;
  font-family: "Questrial", sans-serif;
  color: white;
`;

const DesktopModalWrapper = styled.div`
  display: flex;
  width: 90%;
  margin-left: 5%;
  background-color: black;
  box-shadow: 5px 5px 5px black;
  border-radius: 25px;
  max-height: 85vh;
`;

const MobileModalWrapper = styled.div`
  background-color: black;
  max-height: 105vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
`;

const DesktopImgWrapper = styled.div`
  width: 77.5%;
  height: 100%;
`;

const MobileImgWrapper = styled.div``;

const DesktopDescWrapper = styled.div`
  width: 22.5%;
  background: rgb(189, 189, 189);
  background: black;
  font-size: 16px;
  box-shadow: 5px 5px 5px black;
  padding: 15px;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  overflow: auto;
  border-radius: 20px;
`;

const MobileDescWrapper = styled.div`
  background: rgb(189, 189, 189);
  background: black;
  font-size: 16px;
  box-shadow: 1px 1px 1px black;
  padding: 10px;
  margin-bottom: 25px;
  min-height: 40vh;
  border-radius: 5px;
`;

const FullScreenWrapper = styled.div`
  text-align: center;
  width: 100%;
  height: 100%;
`;

const CustomWrapper = ({
  innerProps,
  children,
  carouselProps: { views },
  carouselProps,
  currentIndex,
  isFullscreen,
}) => {
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 });
  const isTabletOrMobileDevice = useMediaQuery({ maxDeviceWidth: 1224 });
  const description = carouselProps.views[currentIndex].description.replace(
    /^<p class="attachment[^\n]+\n/,
    '',
  );
  const { title } = carouselProps.views[currentIndex];

  const renderDescription = description && (
    <div>
      <Title dangerouslySetInnerHTML={{ __html: title }} />
      <Description dangerouslySetInnerHTML={{ __html: description }} />
      <CommentList views={views} currentIndex={currentIndex} />
      <hr />
      <CommentForm views={views} currentIndex={currentIndex} />
    </div>
  );

  const isHandheld = isTabletOrMobile || isTabletOrMobileDevice;
  const Wrapper = isHandheld ? MobileModalWrapper : DesktopModalWrapper;
  const ImgWrapper = isHandheld ? MobileImgWrapper : DesktopImgWrapper;
  const DescWrapper = isHandheld ? MobileDescWrapper : DesktopDescWrapper;

  return isFullscreen ? (
    <FullScreenWrapper className="disableSave" onContextMenu={(e) => e.preventDefault()} {...innerProps}>{children}</FullScreenWrapper>
  ) : (
    <Wrapper className={`${isHandheld ? 'mobile-image-view' : ''}`}>
      <ImgWrapper className="disableSave" onContextMenu={(e) => e.preventDefault()} {...innerProps}>{children}</ImgWrapper>
      <DescWrapper>{renderDescription}</DescWrapper>
    </Wrapper>
  );
};

CustomWrapper.propTypes = {
  innerProps: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  carouselProps: PropTypes.shape({
    views: PropTypes.arrayOf({
      description: PropTypes.string.isRequired,
    }),
  }).isRequired,
  currentIndex: PropTypes.number.isRequired,
  isFullscreen: PropTypes.bool.isRequired,
};

export default CustomWrapper;
